var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoryIconHovered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "History",
    d: "M78,0H66a4,4,0,0,0-4,4V20a4,4,0,0,0,4,4H78a4,4,0,0,0,4-4V4a4,4,0,0,0-4-4M73,18.51H67a1.5,1.5,0,0,1,0-3h6a1.5,1.5,0,0,1,0,3m4-5.01H67a1.5,1.5,0,0,1,0-3H77a1.5,1.5,0,0,1,0,3m0-5H67a1.5,1.5,0,0,1,0-3H77a1.5,1.5,0,0,1,0,3",
    transform: "translate(-62)",
    fill: "#F5F5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIconHovered);
export default __webpack_public_path__ + "static/media/HistoryIconHovered.2c28f7e75fcf9151273ec67657c4ec93.svg";
export { ForwardRef as ReactComponent };